import { render, staticRenderFns } from "./RadarChart.vue?vue&type=template&id=6d2d043e&scoped=true&"
import script from "./RadarChart.vue?vue&type=script&lang=ts&"
export * from "./RadarChart.vue?vue&type=script&lang=ts&"
import style0 from "./RadarChart.vue?vue&type=style&index=0&id=6d2d043e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2d043e",
  null
  
)

component.options.__file = "RadarChart.vue"
export default component.exports